import { DATE_STATIC_PRESET } from '../../../../constants/selectLists/listItemFiltersList'
import { formatDateBE } from '../../../../constants/dates'
import { BREAKDOWNS, CUSTOM_CONVERSIONS, CUSTOM_EVENTS, LEVEL } from './fields'

const transformMetricsToBE = values => {
  const metrics = Object.keys(values.metrics).reduce((acc, key) => {
    const metricsObj = values.metrics[key]
    const metricsKeys = Object.keys(metricsObj)
    // remove not selected metrics
    const metricsValues = metricsKeys.filter(key => metricsObj[key])
    return [...acc, ...metricsValues]
  }, [])
  return metrics
}

const transformCustomEventsToBE = (metricSelection = {}) => {
  return Object.keys(metricSelection).filter(key => metricSelection[key])
}
const transformCustomConversionsToBE = (metricSelection = {}, customConversionsList = []) => {
  const selectedIds = Object.keys(metricSelection).filter(key => metricSelection[key])
  // return list of objects with id and name
  return customConversionsList
    .filter(conversion => selectedIds.includes(conversion.id))
    .map(conversion => ({
      id: conversion.id,
      name: conversion.name
    }))
}

export const transformValuesToBE = ({
  values,
  savedDateRange,
  level,
  facebookAdAccountId,
  campaignsIds,
  showLevelSelection,
  customConversionsList
}) => {
  const breakdowns = values[BREAKDOWNS].filter(Boolean)
  const customConversions = transformCustomConversionsToBE(values[CUSTOM_CONVERSIONS], customConversionsList)
  const customEvents = transformCustomEventsToBE(values[CUSTOM_EVENTS])

  return {
    insights: transformMetricsToBE(values),
    ...(customConversions?.length > 0 && { [CUSTOM_CONVERSIONS]: customConversions }),
    ...(customEvents?.length > 0 && { [CUSTOM_EVENTS]: customEvents }),
    ...(savedDateRange[DATE_STATIC_PRESET] && {
      [DATE_STATIC_PRESET]: savedDateRange[DATE_STATIC_PRESET]
    }),
    ...(savedDateRange.startDate && {
      date_from: formatDateBE(new Date(savedDateRange.startDate))
    }),
    ...(savedDateRange.endDate && {
      date_to: formatDateBE(new Date(savedDateRange.endDate))
    }),
    level: showLevelSelection ? values[LEVEL] : level,
    providers: [
      {
        ad_account_id: facebookAdAccountId,
        platform: 'fb',
        campaigns: campaignsIds
      }
    ],
    ...(breakdowns.length && {
      [BREAKDOWNS]: breakdowns
    })
  }
}
